export const Breakpoints = {
    'xs': '0',
    'sm': '576px',
    'md': '768px',
    'lg': '1024px',
    'xl': '1280px',
};